import Link from "next/link";
import { Fragment } from "react";
import { PrivacyPolicyType } from "../types";

type Prop = {
  policy: PrivacyPolicyType;
};

const PrivacyPolicySectionContentComponent = ({ policy }: Prop) => {
  return (
    <div className="flex flex-col gap-y-3 md:gap-y-6">
      <span className="h5 text-primary">{policy.header}</span>
      {policy.subheader != null && (
        <span className="h6 text-text-color-high-em">{policy.subheader}</span>
      )}
      <div className="flex flex-col gap-y-6 md:gap-y-12">
        {policy.clauses.map((clause, i) => (
          <div key={i} className="flex flex-col gap-y-2 md:gap-y-4">
            <span className="h6 text-color-high-em">{clause.title}</span>
            <div className="text-body-md text-text-color-mid-em">
              {clause.body.split("<br/>").map((bodyContent, i) => (
                <div
                  key={i}
                  className={bodyContent.includes("•") ? "pl-2" : ""}
                >
                  {bodyContent.split("<break-all>").length > 1 ? (
                    <span className="flex">
                      <span className="pr-2">•</span>
                      <span>
                        {bodyContent
                          .split("<break-all>")
                          .map((bodyBreak, i) => {
                            return i === 1 ? (
                              <Link key={i} href={bodyBreak} passHref>
                                <span className="break-all cursor-pointer text-text-color-low-em">
                                  {bodyBreak}
                                </span>
                              </Link>
                            ) : (
                              <span key={i}>
                                {bodyBreak.split("[highlight]").length > 1 ? (
                                  bodyBreak
                                    .replace("•", "")
                                    .split("[highlight]")
                                    .map((highlightText, i) =>
                                      i === 1 ? (
                                        <span
                                          key={i}
                                          className="label-md text-text-color-high-em"
                                        >
                                          {highlightText}
                                        </span>
                                      ) : (
                                        <span key={i}>{highlightText}</span>
                                      )
                                    )
                                ) : (
                                  <span>
                                    {bodyBreak}
                                  </span>
                                )}
                              </span>
                            );
                          })}
                      </span>
                    </span>
                  ) : bodyContent.includes("•") ? (
                    <span className="flex">
                      <span className="pr-2">•</span>
                      <span className="flex flex-col">
                        {bodyContent
                          .replace("•", "")
                          .split(">")
                          .map((bullet, i) => (
                            <span key={i}>
                              {bullet.split("[highlight]").length > 1 ? (
                                bullet
                                  .split("[highlight]")
                                  .map((highlightText, i) =>
                                    i === 1 ? (
                                      <span
                                        key={i}
                                        className="label-md text-text-color-high-em"
                                      >
                                        {highlightText}
                                      </span>
                                    ) : (
                                      <span key={i}>{highlightText}</span>
                                    )
                                  )
                              ) : bullet.split("[highlight-med]").length > 1 ? (
                                bullet
                                  .replace("•", "")
                                  .split("[highlight-med]")
                                  .map((highlightText, i) =>
                                    i === 1 ? (
                                      <span key={i} className="label-md">
                                        {highlightText}
                                      </span>
                                    ) : (
                                      <span key={i}>{highlightText}</span>
                                    )
                                  )
                              ) : (
                                <span key={i}>{bullet}</span>
                              )}
                            </span>
                          ))}
                      </span>
                    </span>
                  ) : (
                    <span key={i}>
                      {bodyContent.includes("info@simplewaste.com") ? (
                        <Fragment>
                          <span>
                            {bodyContent.replace("info@simplewaste.com", "")}
                          </span>
                          <span className="text-primary pl-1">
                            info@simplewaste.com
                          </span>
                        </Fragment>
                      ) : (
                        bodyContent
                      )}
                    </span>
                  )}
                  {!bodyContent.includes("•") && <br />}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrivacyPolicySectionContentComponent;
